var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#0F1419"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.524 14.7756L23.481 8H22.0696L16.8948 13.882L12.7647 8H8L14.2469 16.8953L8 24H9.41143L14.8728 17.787L19.2353 24H24L17.524 14.7756ZM15.5902 16.9734L14.9563 16.0871L9.92043 9.04117H12.0887L16.154 14.7296L16.7852 15.6159L22.0689 23.0096H19.9006L15.5902 16.9734Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXIcon);
export default __webpack_public_path__ + "static/media/x-icon.bddd8c7f389ae714f67f816950101d23.svg";
export { ForwardRef as ReactComponent };